import { Component, Input } from '@angular/core';
import { EVENTS, CLICK_TYPES, CLICK_LOCATIONS } from '@constants/analytics';
import { AnalyticsService } from '@services/analytics.service';

@Component({
	standalone: false,
	selector: 'qe-social-media-icon',
	templateUrl: './social-media-icon.component.html',
	styleUrls: ['./social-media-icon.component.scss']
})
export class SocialMediaIconComponent {
	@Input() public readonly color?: string = 'var(--brandPrimary)';
	@Input() public readonly platform?: string = '';

	constructor(private readonly gtmService: AnalyticsService) {
	}

	public handleClickIcon(): void {
		let socialUrl = '';

		switch (this.platform) {
			case 'facebook':
				socialUrl = 'https://www.facebook.com/EmbracePetInsurance';
				break;
			case 'linkedin':
				socialUrl = 'https://www.linkedin.com/company/embrace-pet-insurance/';
				break;
			case 'instagram':
				socialUrl = 'https://www.instagram.com/embracepetins/?hl=en';
				break;
			case 'tiktok':
				socialUrl = 'https://www.tiktok.com/@embracepetinsurance?lang=en';
				break;
			default:
				break;
		}
		this.gtmService.push({
			event: EVENTS.CLICK,
			click_location: CLICK_LOCATIONS.CONTENT_BOTTOM,
			click_text: `Socials Icon - ${this.platform}`,
			click_type: CLICK_TYPES.BUTTON,
			click_id: `${CLICK_TYPES.BUTTON}-${CLICK_LOCATIONS.CONTENT_BOTTOM}-PostPurchaseSocialLink-${this.platform}`
		});
		window.open(socialUrl, `_blank`);
	}
}
